(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["material-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('velune-material-carousel-lite')) {
  customElements.define('velune-material-carousel-lite', class extends HTMLElement {
    connectedCallback() {
      if (this._mountFrame) return;
      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;
        this.mount();
      });
    }

    mount() {
      if (this.controller || !this.isConnected) return;

      this.carousel = this.querySelector('[data-mc-carousel]');
      this.cards = Array.from(this.querySelectorAll('[data-mc-card]'));

      if (!this.carousel || !this.cards.length) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
      this.lead = Math.max(0, Number(this.dataset.lead) || 0);
      this.autoplay = this.dataset.autoplay !== 'false';
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = 0;
      this.activeCard = this.cards[0];
      this.openCard = null;
      this.visible = false;
      this.interacting = false;
      this.dragging = false;
      this.jumping = false;

      if (this.cards.length > 1) this.addEdgeClones();
      this.trackCards = Array.from(this.carousel.querySelectorAll('.mc-card'));

      this.carousel.addEventListener('scroll', () => this.onScroll(), {
        passive: true,
        signal
      });

      this.carousel.addEventListener('pointerdown', (event) => {
        this.beginInteraction();

        if (
          event.pointerType !== 'mouse' ||
          event.button !== 0 ||
          event.target.closest('button, a, input, select, textarea')
        ) return;

        this.dragging = true;
        this.dragId = event.pointerId;
        this.dragX = event.clientX;
        this.dragScroll = this.carousel.scrollLeft;
        this.carousel.classList.add('mc-dragging');

        try { this.carousel.setPointerCapture(event.pointerId); } catch {}
      }, { passive: true, signal });

      this.carousel.addEventListener('pointermove', (event) => {
        if (!this.dragging || event.pointerId !== this.dragId) return;
        this.carousel.scrollLeft = this.dragScroll - (event.clientX - this.dragX);
        event.preventDefault();
      }, { passive: false, signal });

      const endPointer = (event) => {
        if (this.dragging && (this.dragId === null || event.pointerId === this.dragId)) {
          this.dragging = false;
          this.carousel.classList.remove('mc-dragging');

          try {
            if (this.carousel.hasPointerCapture(event.pointerId)) {
              this.carousel.releasePointerCapture(event.pointerId);
            }
          } catch {}

          this.dragId = null;
          this.center(this.closestCard(), this.reduced.matches ? 'auto' : 'smooth');
        }

        this.endInteraction();
      };

      this.carousel.addEventListener('pointerup', endPointer, { passive: true, signal });
      this.carousel.addEventListener('pointercancel', endPointer, { passive: true, signal });

      this.carousel.addEventListener('wheel', (event) => {
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        const shifted = event.shiftKey && Math.abs(event.deltaY) > 0;

        if (!horizontal && !shifted) return;

        event.preventDefault();
        this.beginInteraction();
        this.carousel.scrollLeft += horizontal ? event.deltaX : event.deltaY;
        this.endInteraction();
      }, { passive: false, signal });

      this.carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.closeDetails();
          this.beginInteraction();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
          this.endInteraction();
        } else if (event.key === 'Escape') {
          this.closeDetails(true);
        }
      }, { signal });

      this.addEventListener('click', (event) => this.onClick(event), { signal });

      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stopAuto() : this.scheduleAuto();
      }, { signal });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.center(this.cards[this.activeIndex] || this.cards[0], 'auto');
        }, 100);
      }, { passive: true, signal });

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.visible = Boolean(entries[0]?.isIntersecting);
          this.visible ? this.scheduleAuto() : this.stopAuto();
        }, {
          threshold: 0.01,
          rootMargin: `${this.lead}px 0px`
        });

        this.visibilityObserver.observe(this);
      } else {
        this.visible = true;
      }

      this.center(this.cards[0], 'auto');
      this.carousel.classList.add('mc-ready');
      this.ready = true;
      this.scheduleAuto();
    }

    addEdgeClones() {
      this.leading = this.cloneCard(this.cards[this.cards.length - 1]);
      this.trailing = this.cloneCard(this.cards[0]);

      this.carousel.prepend(this.leading);
      this.carousel.append(this.trailing);
    }

    cloneCard(card) {
      const clone = card.cloneNode(true);

      clone.dataset.mcClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      clone.removeAttribute('aria-label');
      clone.removeAttribute('data-shopify-editor-block');
      clone.classList.remove('mc-active', 'mc-show-info');

      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));

      clone.querySelectorAll('[aria-controls], [aria-labelledby]').forEach((node) => {
        node.removeAttribute('aria-controls');
        node.removeAttribute('aria-labelledby');
      });

      clone.querySelectorAll('button, a, input, select, textarea').forEach((node) => {
        node.tabIndex = -1;
      });

      clone.querySelectorAll('[data-mc-details]').forEach((node) => {
        node.setAttribute('aria-hidden', 'true');
      });

      clone.querySelectorAll('[data-mc-open]').forEach((node) => {
        node.setAttribute('aria-expanded', 'false');
      });

      clone.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';
      });

      return clone;
    }

    closestCard() {
      const center = this.carousel.scrollLeft + this.carousel.clientWidth / 2;
      let closest = null;
      let best = Infinity;

      for (const card of this.trackCards) {
        const distance = Math.abs(
          card.offsetLeft + card.offsetWidth / 2 - center
        );

        if (distance < best) {
          best = distance;
          closest = card;
        }
      }

      return closest;
    }

    setActive(card) {
      if (!card) return;

      const index = Number(card.dataset.index);
      if (Number.isFinite(index)) this.activeIndex = index;

      if (card === this.activeCard) return;

      this.activeCard?.classList.remove('mc-active');
      card.classList.add('mc-active');
      this.activeCard = card;
    }

    center(card, behavior = 'smooth') {
      if (!card) return;

      const target =
        card.offsetLeft -
        (this.carousel.clientWidth - card.offsetWidth) / 2;

      if (
        behavior !== 'smooth' ||
        this.reduced.matches ||
        Math.abs(target - this.carousel.scrollLeft) < 2
      ) {
        cancelAnimationFrame(this.slideRaf);
        this.slideRaf = 0;
        this.carousel.classList.remove('mc-animating');
        this.carousel.scrollLeft = target;
        return;
      }

      cancelAnimationFrame(this.slideRaf);

      const start = this.carousel.scrollLeft;
      const distance = target - start;
      const duration = 680;
      const startedAt = performance.now();

      this.carousel.classList.add('mc-animating');

      const animate = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);

        const eased = progress < .5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        this.carousel.scrollLeft = start + distance * eased;

        if (progress < 1) {
          this.slideRaf = requestAnimationFrame(animate);
          return;
        }

        this.slideRaf = 0;
        this.carousel.scrollLeft = target;
        this.carousel.classList.remove('mc-animating');
      };

      this.slideRaf = requestAnimationFrame(animate);
    }

    move(direction) {
      if (this.cards.length < 2 || this.jumping) return;

      const index = this.activeIndex;
      let target;

      if (direction > 0) {
        target = index >= this.cards.length - 1
          ? this.trailing
          : this.cards[index + 1];
      } else {
        target = index <= 0
          ? this.leading
          : this.cards[index - 1];
      }

      this.center(target, this.reduced.matches ? 'auto' : 'smooth');
    }

    onScroll() {
      if (this.jumping) return;

      if (!this.scrollRaf) {
        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = 0;
          this.setActive(this.closestCard());
        });
      }

      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => this.finishScroll(), 140);
    }

    finishScroll() {
      const card = this.closestCard();
      if (!card) return;

      this.setActive(card);

      if (!card.dataset.mcClone) return;

      const index = Number(card.dataset.index);
      const realCard = this.cards[Number.isFinite(index) ? index : 0];
      if (!realCard) return;

      this.jumping = true;
      this.center(realCard, 'auto');
      this.setActive(realCard);

      requestAnimationFrame(() => {
        this.jumping = false;
      });
    }

    canAuto() {
      return (
        this.autoplay &&
        this.cards.length > 1 &&
        this.ready &&
        this.visible &&
        !document.hidden &&
        !this.interacting &&
        !this.openCard &&
        !this.dragging &&
        !this.jumping
      );
    }

    stopAuto() {
      clearTimeout(this.autoTimer);
      this.autoTimer = 0;
    }

    scheduleAuto() {
      this.stopAuto();
      if (!this.canAuto()) return;

      this.autoTimer = setTimeout(() => {
        this.autoTimer = 0;

        if (!this.canAuto()) {
          this.scheduleAuto();
          return;
        }

        this.move(1);
        this.scheduleAuto();
      }, this.interval);
    }

    beginInteraction() {
      this.interacting = true;

      cancelAnimationFrame(this.slideRaf);
      this.slideRaf = 0;
      this.carousel.classList.remove('mc-animating');

      clearTimeout(this.interactionTimer);
      this.stopAuto();
    }

    endInteraction() {
      clearTimeout(this.interactionTimer);

      this.interactionTimer = setTimeout(() => {
        this.interacting = false;
        this.scheduleAuto();
      }, 900);
    }

    onClick(event) {
      const prev = event.target.closest('[data-mc-prev]');
      const next = event.target.closest('[data-mc-next]');
      const open = event.target.closest('[data-mc-open]');
      const close = event.target.closest('[data-mc-close]');

      if (prev || next) {
        this.closeDetails();
        this.beginInteraction();
        this.move(next ? 1 : -1);
        this.endInteraction();
        return;
      }

      if (open) {
        const card = open.closest('[data-mc-card]');
        if (!card || card.dataset.mcClone) return;

        this.openDetails(card, open);
        return;
      }

      if (close) {
        const card = close.closest('[data-mc-card]');
        if (card) this.closeDetails(true, card);
      }
    }

    openDetails(card, button) {
      if (this.openCard && this.openCard !== card) {
        this.closeDetails(false);
      }

      this.center(card, this.reduced.matches ? 'auto' : 'smooth');

      card.classList.add('mc-show-info');
      button.classList.add('mc-hidden');
      button.setAttribute('aria-expanded', 'true');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'false');

      this.openCard = card;
      this.stopAuto();
    }

    closeDetails(focus = false, card = this.openCard) {
      if (!card) return;

      card.classList.remove('mc-show-info');

      const button = card.querySelector('[data-mc-open]');
      button?.classList.remove('mc-hidden');
      button?.setAttribute('aria-expanded', 'false');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'true');

      if (this.openCard === card) this.openCard = null;
      if (focus) button?.focus();

      this.scheduleAuto();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._mountFrame);
      cancelAnimationFrame(this.scrollRaf);
      cancelAnimationFrame(this.slideRaf);

      clearTimeout(this.autoTimer);
      clearTimeout(this.interactionTimer);
      clearTimeout(this.scrollTimer);
      clearTimeout(this.resizeTimer);

      this.visibilityObserver?.disconnect();
      this.controller?.abort();

      this.leading?.remove();
      this.trailing?.remove();

      this.controller = null;
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-arizona-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vas-prev], [data-vas-next]');
    if (!button) return;

    const section = button.closest('[data-velune-arizona-story]');
    const rail = section?.querySelector('[data-vas-rail]');
    const card = rail?.querySelector('.velune-arizona-story__card');
    if (!rail || !card) return;

    const styles = getComputedStyle(rail);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 10;
    const direction = button.hasAttribute('data-vas-prev') ? -1 : 1;

    rail.scrollBy({
      left: direction * (card.offsetWidth + gap),
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-boston-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.vbcReady === 'true') return;
      root.dataset.vbcReady = 'true';

      const rail = root.querySelector('[data-vbc-rail]');
      const panels = [...root.querySelectorAll('[data-vbc-panel]')];
      const tabs = [...root.querySelectorAll('[data-vbc-tab]')];
      const dots = [...root.querySelectorAll('.vbc__progress-dot')];

      if (!rail || !panels.length) return;

      const setActive = (index) => {
        tabs.forEach((tab, i) => tab.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = Number(tab.dataset.vbcTab || 0);
          panels[index]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
          setActive(index);
        });
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          let best = null;
          for (const entry of entries) {
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          }
          if (!best || best.intersectionRatio < .55) return;
          const index = panels.indexOf(best.target);
          if (index >= 0) setActive(index);
        }, {
          root: rail,
          threshold: [.55, .7, .9]
        });

        panels.forEach((panel) => observer.observe(panel));
      }
    };

    const boot = () => {
      document.querySelectorAll('[data-vbc-root]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector?.('[data-vbc-root]') || event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-boston-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vas-prev], [data-vas-next]');
    if (!button) return;

    const section = button.closest('[data-velune-boston-story]');
    const rail = section?.querySelector('[data-vas-rail]');
    const card = rail?.querySelector('.velune-boston-story__card');
    if (!rail || !card) return;

    const styles = getComputedStyle(rail);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 10;
    const direction = button.hasAttribute('data-vas-prev') ? -1 : 1;

    rail.scrollBy({
      left: direction * (card.offsetWidth + gap),
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-maxx-tracking"] && !Shopify.designMode) return;
  try {
    
if (!window.veluneMaxxTrackingInstalled) {
  window.veluneMaxxTrackingInstalled = true;
  let provider;

  const loadProvider = () => {
    if (window.YQV5) return Promise.resolve();
    if (provider) return provider;

    provider = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timer = setTimeout(() => {
        script.remove();
        reject(new Error('timeout'));
      }, 12000);

      script.src = 'https://www.17track.net/externalcall.js';
      script.async = true;
      script.onload = () => {
        clearTimeout(timer);
        window.YQV5 ? resolve() : reject(new Error('unavailable'));
      };
      script.onerror = () => {
        clearTimeout(timer);
        script.remove();
        reject(new Error('network'));
      };
      document.head.append(script);
    }).catch((error) => {
      provider = null;
      throw error;
    });

    return provider;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const scope = form.closest('[data-maxx-tracking]');
    if (!scope) return;

    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;

    const number = form.elements.nums.value.trim();
    if (!form.reportValidity()) return;

    const status = scope.querySelector('[data-track-status]');
    const fallback = scope.querySelector('[data-track-fallback]');
    fallback.href = 'https://t.17track.net/en#nums=' + encodeURIComponent(number);
    fallback.hidden = false;
    button.disabled = true;
    status.textContent = status.dataset.loading;

    try {
      await loadProvider();
      if (!scope.isConnected) return;
      window.YQV5.trackSingle({
        YQ_ContainerId: scope.querySelector('[data-track-result]').id,
        YQ_Height: 560,
        YQ_Fc: '0',
        YQ_Lang: 'en',
        YQ_Num: number
      });
      status.textContent = '';
    } catch (error) {
      status.textContent = status.dataset.error;
    } finally {
      button.disabled = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-product-details-global"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('velune-product-details')) {
  customElements.define('velune-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this._onClick) return;

      this._onClick = (event) => {
        const tab = event.target.closest('.velune-product-details__tab');
        if (!tab || !this.contains(tab)) return;

        const wasOpen = tab.getAttribute('aria-expanded') === 'true';
        const current = this.querySelector('.velune-product-details__tab[aria-expanded="true"]');

        if (current) this.setState(current, false);
        if (!wasOpen) this.setState(tab, true);
      };

      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (!this._onClick) return;
      this.removeEventListener('click', this._onClick);
      this._onClick = null;
    }

    setState(tab, open) {
      tab.setAttribute('aria-expanded', String(open));

      const panel = this.ownerDocument.getElementById(tab.getAttribute('aria-controls'));
      if (panel && this.contains(panel)) panel.hidden = !open;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slide"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('velune-video-strip')) {

  customElements.define(
    'velune-video-strip',

    class extends HTMLElement {

      connectedCallback() {

        if (this.initialized) return;

        this.initialized = true;

        this.track =
          this.querySelector('[data-vr-track]');

        this.videos =
          Array.from(
            this.querySelectorAll('[data-vr-video]')
          );

        if (!this.track || !this.videos.length) {
          return;
        }


        /*
          ==============================
          INITIAL STATE
          ==============================
        */

        this.videos.forEach((video, index) => {

          video.muted = true;
          video.defaultMuted = true;

          /*
            Os três primeiros podem começar
            assim que a section ficar visível.
          */

          video.dataset.firstThree =
            index < 3
              ? 'true'
              : 'false';


          /*
            Remove poster somente após
            reprodução real.
          */

          const poster =
            video
              .closest('[data-vr-card]')
              ?.querySelector('.vr-poster');

          if (poster) {

            video.addEventListener(
              'playing',

              () => {
                poster.hidden = true;
              },

              {
                once: true
              }
            );

          }

        });


        /*
          ==============================
          EVENT DELEGATION
          ==============================
        */

        this.handleClick =
          this.onClick.bind(this);

        this.handleVisibility =
          this.onVisibility.bind(this);

        this.addEventListener(
          'click',
          this.handleClick
        );

        document.addEventListener(
          'visibilitychange',
          this.handleVisibility
        );


        /*
          ==============================
          CAROUSEL VIDEO OBSERVER

          O próprio track é usado como root.

          Isso significa que um vídeo posterior
          começa quando entra de fato na área
          visível do carrossel.
          ==============================
        */

        if ('IntersectionObserver' in window) {

          this.videoObserver =
            new IntersectionObserver(

              entries => {

                entries.forEach(entry => {

                  const video = entry.target;

                  /*
                    Pelo menos 55% do vídeo
                    precisa estar dentro do
                    carrossel para reproduzir.
                  */

                  if (
                    entry.isIntersecting &&
                    entry.intersectionRatio >= 0.55
                  ) {

                    this.playVideo(video);

                  } else {

                    video.pause();

                  }

                });

              },

              {
                root: this.track,

                threshold: [
                  0,
                  0.25,
                  0.55,
                  0.75,
                  1
                ]
              }

            );


          this.videos.forEach(video => {

            this.videoObserver.observe(video);

          });

        }


        /*
          ==============================
          SECTION OBSERVER

          Evita iniciar vídeos quando toda
          a section ainda está fora da tela.
          ==============================
        */

        if ('IntersectionObserver' in window) {

          this.sectionObserver =
            new IntersectionObserver(

              entries => {

                const entry = entries[0];

                if (!entry) return;


                if (entry.isIntersecting) {

                  /*
                    Inicia imediatamente os
                    três primeiros.
                  */

                  this.playFirstThree();

                } else {

                  /*
                    Section saiu da viewport:
                    pausa tudo.
                  */

                  this.pauseAll();

                }

              },

              {
                rootMargin: '100px 0px',
                threshold: 0.05
              }

            );


          this.sectionObserver.observe(this);

        } else {

          /*
            Fallback para browsers antigos.
          */

          this.playFirstThree();

        }

      }


      /*
        ==============================
        PLAY FIRST 3
        ==============================
      */

      playFirstThree() {

        if (document.hidden) return;

        this.videos
          .slice(0, 3)
          .forEach(video => {

            this.playVideo(video);

          });

      }


      /*
        ==============================
        SAFE PLAY
        ==============================
      */

      playVideo(video) {

        if (
          !video ||
          document.hidden
        ) {
          return;
        }


        const result =
          video.play();


        if (result?.catch) {

          result.catch(() => {});

        }

      }


      /*
        ==============================
        PAUSE ALL
        ==============================
      */

      pauseAll() {

        this.videos.forEach(video => {

          video.pause();

        });

      }


      /*
        ==============================
        PAGE VISIBILITY
        ==============================
      */

      onVisibility() {

        if (document.hidden) {

          this.pauseAll();

          return;

        }


        /*
          Ao voltar para a aba,
          restauramos os três primeiros.

          O observer do carrossel controla
          os demais.
        */

        this.playFirstThree();

      }


      /*
        ==============================
        SOUND CONTROL
        ==============================
      */

      onClick(event) {

        const button =
          event.target.closest(
            '[data-vr-sound]'
          );

        if (
          !button ||
          !this.contains(button)
        ) {
          return;
        }


        const card =
          button.closest(
            '[data-vr-card]'
          );

        const video =
          card?.querySelector(
            '[data-vr-video]'
          );

        if (!video) {
          return;
        }


        /*
          Se estava muted,
          vamos ligar.
        */

        const enableSound =
          video.muted;


        /*
          Apenas um vídeo pode ter
          áudio ativo por vez.
        */

        if (enableSound) {

          this.videos.forEach(otherVideo => {

            if (otherVideo === video) {
              return;
            }


            otherVideo.muted = true;


            const otherButton =
              otherVideo
                .closest('[data-vr-card]')
                ?.querySelector(
                  '[data-vr-sound]'
                );


            if (otherButton) {

              otherButton.setAttribute(
                'aria-pressed',
                'false'
              );

              otherButton.setAttribute(
                'aria-label',
                'Enable sound'
              );

            }

          });

        }


        /*
          Alterna áudio.
        */

        video.muted =
          !enableSound;


        button.setAttribute(
          'aria-pressed',
          enableSound
            ? 'true'
            : 'false'
        );


        button.setAttribute(
          'aria-label',
          enableSound
            ? 'Disable sound'
            : 'Enable sound'
        );


        /*
          Se usuário ativou áudio,
          garante que vídeo esteja rodando.
        */

        if (enableSound) {

          this.playVideo(video);

        }

      }


      /*
        ==============================
        CLEANUP
        ==============================
      */

      disconnectedCallback() {

        this.videoObserver?.disconnect();

        this.sectionObserver?.disconnect();


        if (this.handleClick) {

          this.removeEventListener(
            'click',
            this.handleClick
          );

        }


        if (this.handleVisibility) {

          document.removeEventListener(
            'visibilitychange',
            this.handleVisibility
          );

        }


        this.pauseAll();

        this.initialized = false;

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();
})();
